import {
	BIDDER_RFX_DEFAULT_TAB,
	BidderRfxTab,
} from "newui/features/Rfx/surfaces/bidder-rfx-list-surface";
import { RfxSupplierPaths, BaseMemberPaths } from "./navigation.types";
import {
	RFX_DEFAULT_TAB,
	RFX_SCOPE_ROUTE_SEGMENTS,
} from "newui/features/Rfx/tabs/rfx-tab-config";

export class SupplierPaths extends BaseMemberPaths {
	shareProfile: string;

	rfx: RfxSupplierPaths;

	constructor(companyId: number) {
		super(companyId);

		this.shareProfile = this.prefixWithBasePath("profile/share");

		this.home = this.companyProfile.information;

		// The five bidder tabs are now routed segments of the consolidated
		// Tenders & Quotes list, not flat sibling paths. The old values
		// (`rfx/accepted` etc.) were never registered routes — they resolved to
		// nothing. `Supplier.js` keeps redirects from them for old bookmarks.
		const bidderTab = (tab: BidderRfxTab): string =>
			this.prefixWithBasePath(
				`rfx/${RFX_SCOPE_ROUTE_SEGMENTS.tenders_quotes}/${tab}`
			);

		this.rfx = {
			all: bidderTab("all"),
			accepted: bidderTab("accepted"),
			awarded: bidderTab("awarded"),
			submitted: bidderTab("submitted"),
			unsuccessful: bidderTab("unsuccessful"),
			// The supplier menu's T&Q link must open the BIDDER default tab —
			// this previously used the procurer `RFX_DEFAULT_TAB` ("current"),
			// which is not a bidder tab at all.
			tendersQuotes: bidderTab(BIDDER_RFX_DEFAULT_TAB),
			approvals: this.prefixWithBasePath(
				`rfx/${RFX_SCOPE_ROUTE_SEGMENTS.approvals}/${RFX_DEFAULT_TAB}`
			),
			panel: this.prefixWithBasePath(
				`rfx/${RFX_SCOPE_ROUTE_SEGMENTS.panel}/${RFX_DEFAULT_TAB}`
			),
		};
	}
}
